export default "__VITE_ASSET__cEophBMV__"